import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Clock, Target, Layout, Rocket } from 'lucide-react';
const benefits = [{
  icon: Clock,
  text: 'Producí creativos en minutos, no horas'
}, {
  icon: Target,
  text: 'Generá el ángulo correcto sin adivinar: dolor, deseo, FOMO o identidad'
}, {
  icon: Layout,
  text: 'Creativos multiformato: carruseles, VSLs, Reels, Newsletters'
}, {
  icon: Rocket,
  text: 'Sin curva de aprendizaje técnica: listo en 30 minutos'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
export function BenefitsSection() {
  return <section className="bg-black py-24 px-4" data-id="element-29">
      <div className="max-w-7xl mx-auto" data-id="element-30">
        <div className="text-center mb-16" data-id="element-31">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white" data-id="element-32">
            Qué Vas a Lograr con{' '}
            <span className="text-matrix-green text-glow-green" data-id="element-33">
              PromptAdsPro
            </span>
          </motion.h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-5xl mx-auto rounded-2xl overflow-hidden border border-matrix-green/20 shadow-[0_0_40px_rgba(0,255,65,0.15)] relative" data-id="element-34">
          <div className="absolute inset-0 bg-matrix-green/5 mix-blend-overlay pointer-events-none" data-id="element-35" />
          <img src="https://i.postimg.cc/SxHBM3NJ/4.webp" alt="Beneficios: En 30 minutos, Multiformato, Sistema Estratégico, Mejora CTR" className="w-full h-auto object-cover" data-id="element-36" />
        </motion.div>
      </div>
    </section>;
}